import { defineStore } from 'pinia'
import { useAuthStore } from './AuthStore.js';
import Api from '../api/Api'

export const useRecycleBinStore = defineStore('recycleBin', {
  state: () => ({
    nodes: [],
    selectedNode: null,
    isRefreshingNodes: false,
    restoringPodIds: [],
    selectedPodIds: [],
  }),
  getters: {
    getAllNodes: function (state) {
      return state.nodes;
    },


    getNodeById: function (state) {
      return (nodeId) => state.nodes.find((node) => node.id === nodeId);
    },
    getChildNodes: function (state) {
      return (parentNodeId) => state.nodes.filter((node) => node.parentid === parentNodeId);
    },
    getIsRefreshingNodes: function (state) {
      return state.isRefreshingNodes;
    },
    getAllPods(state) {
      let pods = [];

      for (let i=0; i < state.nodes.length; i++) {
        if (Array.isArray(state.nodes[i].pods)) {
          pods = pods.concat(state.nodes[i].pods);
        }
      }

      return pods
      .filter((pod) => pod.deletedat !== null)
      .filter((pod) => pod.parentpodid === null);
    },
    getSelectedPods(state) {
      return this.getAllPods.filter((pod) => state.selectedPodIds.includes(pod.id));
    },
    getDeletedPodVersions(state) {
      return function(podId) {
        let pods = [];

        for (let i=0; i < state.nodes.length; i++) {
          if (Array.isArray(state.nodes[i].pods)) {
            const matchedPods = state.nodes[i].pods
            .filter((pod) => pod.deletedat !== null)
            .filter((pod) => pod.parentpodid === podId || pod.id === podId);

            pods = pods.concat(matchedPods);
          }
        }

        return pods;
      }
    },
    isRestoringPodIds(state) {
      return (podIds) => {
        return state.restoringPodIds.some((podId) => podIds.includes(podId));
      };
    }
  },
  actions: {
    _removePodById(podId) {
      // Delete pods, but keep the nodes with empty pods array
      for (let i = 0; i < this.nodes.length; i++) {
        if (!Array.isArray(this.nodes[i].pods)) {
          continue;
        }

        for (let j = 0; j < this.nodes[i].pods.length; j++) {
          if (this.nodes[i].pods[j].id === podId) {
            this.nodes[i].pods.splice(j, 1);
            break;
          }
        }
      }

      this.selectedPodIds = this.selectedPodIds.filter((id) => id !== podId);
    },


    refreshNodesList: async function (payload) {
      if (!payload.silent) {
        this.isRefreshingNodes = true;
      }

      try {
        const results = await Api.recycleBin.listNodes(payload.rootNodeId);
        this.nodes = results.data;
      } finally {
        if (!payload.silent) {
          this.isRefreshingNodes = false;
        }
      }
    },
    permanentlyDeletePods: async function (podIds) {
      const authStore = useAuthStore();
      const rootNodeId = authStore.rootNodeId;

      await Api.recycleBin.permanentlyDeletePods(rootNodeId, podIds);
      for (let i = 0; i < podIds.length; i++) {
        this._removePodById(podIds[i]);
      }
    },
    restorePods: async function (podIds) {
      const authStore = useAuthStore();
      const rootNodeId = authStore.rootNodeId;

      try {
        this.restoringPodIds = podIds;
        await Api.recycleBin.restorePods(rootNodeId, podIds);
        for (let i = 0; i < podIds.length; i++) {
          this._removePodById(podIds[i]);
        }
      } finally {
        this.restoringPodIds = [];
      }
    },
    emptyRecycleBin: async function () {
      const authStore = useAuthStore();
      const rootNodeId = authStore.rootNodeId;

      await Api.recycleBin.emptyRecycleBin(rootNodeId);
      this.nodes = [];
    },
    updateRecycleBinPod: function(pod) {
      for (let i = 0; i < this.nodes.length; i++) {
        if (Array.isArray(this.nodes[i].pods)) {
          for (let j = 0; j < this.nodes[i].pods.length; j++) {
            if (this.nodes[i].pods[j].id === pod.id) {
              Object.assign(this.nodes[i].pods[j], pod);
            }
          }
        }
      }

      if (!pod.deletedat) {
        this.selectedPodIds = this.selectedPodIds.filter((id) => id !== pod.id);
      }
    },
    updateRecycleBinNode(node) {
      for (let i = 0; i < this.nodes.length; i++) {
        if (this.nodes[i].id === node.id) {
          let nodePods = this.nodes[i].pods;
          Object.assign(this.nodes[i], node);
          this.nodes[i].pods = nodePods;
          break;
        }
      }
    },
    podPermanentlyDeletedNotification: function(podids) {
      for (let i = 0; i < podids.length; i++) {
        this._removePodById(podids[i]);
      }
    },
    togglePodSelection: function (podId) {
      if (this.selectedPodIds.includes(podId)) {
        this.selectedPodIds = this.selectedPodIds.filter((id) => id !== podId);
      } else {
        this.selectedPodIds.push(podId);
      }
    },
    deselectAllPods: function () {
      this.selectedPodIds = [];
    },
    reset: function () {
      this.nodes = [];
      this.selectedPodIds = [];
      this.isRefreshingNodes = false;
      this.restoringPodIds = [];
      this.selectedPodIds = [];
    },
  },
});
